import * as S from "./style";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import { Grid } from "@mui/material";

import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo-notext.png";
import { ROUTES } from "common/constant/routes";
import { useLanguage } from "contexts/LanguageContext";
import ProfileBadge from "components/ProfileSection/ProfileBadge";
import ThemeSelector from 'components/ProfileSection/ThemeSelector';

interface TopToolbarProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
}

export default function TopToolbar({ searchValue, onSearchChange }: TopToolbarProps) {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <AppBar position="static" elevation={3} style={{ backgroundColor: "transparent" }}>
      <Toolbar>
        <Grid container alignItems="center" width="100%">
          <Grid size={{ xs: 3 }} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              component="img"
              src={Logo}
              alt="Logo"
              sx={{ height: 30, "&:hover": { cursor: "pointer" } }}
              onClick={() => navigate(ROUTES.DASHBOARD)}
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ display: "flex", justifyContent: "center" }}>
            <S.Search>
              <S.SearchIconWrapper>
                <SearchIcon />
              </S.SearchIconWrapper>
              <S.StyledInputBase
                placeholder={t('search.placeholder')}
                inputProps={{ "aria-label": "search" }}
                value={searchValue ?? ""}
                onChange={(e) => onSearchChange?.(e.target.value)}
              />
            </S.Search>
          </Grid>
          <S.StyledGrid size={{ xs: 3 }}>
            <S.StyledBox>
              <ThemeSelector />
              <ProfileBadge hideText />
            </S.StyledBox>
          </S.StyledGrid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
